<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre3" id="pgepubid00000">The Lone Star Ranger</h1>
<h2 class="calibre3 sigil_not_in_toc">A Romance of the Border</h2>
<h2 class="sigil_not_in_toc">Zane Grey</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?689947cc